import { render, staticRenderFns } from "./InvitationTopicSelect.vue?vue&type=template&id=672b893c&"
import script from "./InvitationTopicSelect.vue?vue&type=script&lang=js&"
export * from "./InvitationTopicSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports